/**
 * Returns true when the given value is a canonical UUID (8-4-4-4-12 hex).
 * Used to tell apart legacy uuid-based detail links from the new slug-based
 * ones, so the right backend endpoint (`/single/:uuid` vs `/single-by-slug/:slug`)
 * can be chosen.
 */
export const isUuid = (value: unknown): boolean =>
  typeof value === "string" &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
